import { NoteFilterInput } from '../gql/graphql';
import { getPaginatedNodes } from './utils';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const GET_NOTES = graphql(`
  query getNotes($filters: NoteFilterInput!) {
    notes(pagination: { first: 500 }, filters: $filters) {
      edges {
        cursor
        node {
          uuid
          note
          createdAt
          updatedAt
          user {
            cursor
            node {
              uuid
              username
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`);

export function useGetNotes(filters: NoteFilterInput) {
  const { loading, error, data } = useQuery(GET_NOTES, {
    variables: {
      filters,
    },
  });

  const { notes, hasNotes } = useMemo(() => {
    return {
      notes: getPaginatedNodes(data?.notes),
      hasNotes: (data?.notes?.edges?.length ?? 0) > 0,
    };
  }, [data]);

  return {
    loading,
    error,
    data,
    notes,
    hasNotes,
  };
}
